<footer>
  <div class="footer-content left-content">
    <div *ngIf="iS.getWhiteLabel && iS.getWhiteLabel?.type === 'basic'">Powered By:</div>
    <ng-container *ngIf="iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance';else normalLogo">
      <img [src]="'/assets/images/' + iS.getWhiteLabel.logo" class="logo" alt="" [style]="{height:'64px'}">
    </ng-container>
    <ng-template #normalLogo>
      <img [src]="isIiccs ? '/assets/images/iiccsforum2025.webp':'/assets/images/logo.png'" class="logo" alt="">
    </ng-template>
    <ng-container *ngIf="isIiccs;else normalFooter">
      <div class="link-container">
        <a class="link" [attr.href]="!iS.isSukha ?  'https://wa.me/6285173229332' : null">
          <img src="/assets/images/icons/wa.svg" alt="wa" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Whatsapp' | translate }}</p>
            <p>+62 851-7322-9332</p>
          </div>
        </a>
        <a class="link" [attr.href]="!iS.isSukha ? 'mailto:registration@iiccsforum.com' : null">
          <img src="/assets/images/icons/mail.svg" alt="mail" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Email' | translate }}</p>
            <p>registration&#64;iiccsforum.com</p>
          </div>
        </a>
      </div>
      <div class="link-container mt-3">
        <a class="link" href="https://www.google.co.uk/maps/place/Plaza+Asia,+Senayan,+Kec.+Kby.+Baru,+Kota+Jakarta+Selatan,+Daerah+Khusus+Ibukota+Jakarta/@-6.2254512,106.8045194,19z/data=!3m1!4b1!4m6!3m5!1s0x2e69f14e34f35ea9:0xcf7662c9e32e5ac7!8m2!3d-6.2254512!4d106.8051631!16s%2Fg%2F11bw4j7h8r?entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D" target="_blank" >
          <img src="/assets/images/icons/address.svg" alt="address" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Address' | translate }}</p>
            <p>Plaza Asia, 18th Floor,
              Jl. Jend. Sudirman Kav 59, Jakarta Selatan 12190, Indonesia</p>
          </div>
        </a>
      </div>
    </ng-container>
    <ng-template #normalFooter>
      <div class="link-container">
        <a class="link" [attr.href]="!iS.isSukha ? (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? 'https://wa.me/' + iS.getWhiteLabel?.wa : 'https://wa.me/6282125999908') : null">
          <img src="/assets/images/icons/wa.svg" alt="wa" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Whatsapp' | translate }}</p>
            <p>{{ (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? iS.getWhiteLabel?.phone : '+62821-2599-9908') }}</p>
          </div>
        </a>
        <a class="link" [attr.href]="!iS.isSukha ? (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? 'mailto:'+iS.getWhiteLabel?.email : 'mailto:info@addtix.id') : null">
          <img src="/assets/images/icons/mail.svg" alt="mail" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Email' | translate }}</p>
            <p>{{ (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? iS.getWhiteLabel?.email : 'info@addtix.id') }}</p>
          </div>
        </a>
      </div>
      <div class="link-container mt-3">
        <a class="link" href="https://www.google.com/maps/place/Epiwalk/@-6.2181002,106.8304102,1421m/data=!3m2!1e3!4b1!4m6!3m5!1s0x2e69f40831e56edf:0x3baf62dc4159d8b1!8m2!3d-6.2181002!4d106.8352811!16s%2Fg%2F11cs3yl10c?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank" >
          <img src="/assets/images/icons/address.svg" alt="address" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Address' | translate }}</p>
            <p>{{ (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? iS.getWhiteLabel?.address : 'Epiwalk Office Suite Level 5 Unit 529A, Jl. H. R. Rasuna Said, Jakarta 12940') }}</p>
          </div>
        </a>
      </div>
    </ng-template>
  </div>
  <ng-container *ngIf="!isIiccs && !iS.getWhiteLabel">
    <div class="footer-content center-content" *ngIf="!iS.isSukha && !iS.isOnePiece && !iS.isAK && !iS.isRichieRen && !iS.isHillsong">
<!--      <h3>{{ 'Company' | translate }}</h3>-->
<!--      <a [routerLink]="['/about-us']">{{ 'About Us' | translate }}</a>-->
    </div>
    <div class="footer-content center-content" *ngIf="!iS.isSukha && !iS.isOnePiece && !iS.isAK && !iS.isRichieRen && !iS.isHillsong">
<!--      <h3>{{ 'Customer Care' | translate }}</h3>-->
<!--      <a [routerLink]="['/faq']">{{ 'FAQs' | translate }}</a>-->
      <!-- <a [routerLink]="['/privacy-policy']">{{ 'Privacy & Policy' | translate }}</a> -->
      <!-- <a [routerLink]="['/terms-condition']">{{ 'Terms of Use' | translate }}</a> -->
    </div>
  </ng-container>

  <div class="footer-content center-content" [class.w-100]="iS.isSukha" *ngIf="iS.isSukha">
    <h3>{{ 'Customer Care' | translate }}</h3>
    <div class="w-75 fs-6 d-inline-block" [class.w-100]="iS.isSukha">
      <span>Produk atau jasa ini disediakan dan menjadi tanggung jawab ADDTix. Untuk
        layanan contact center ADDTix hubungi +62821-2599-9908 atau info&#64;addtix.id. Cek Syarat dan Ketentuan layanan lengkap </span>
      <a href="https://bmri.id/sukhatncxaddtix" class="fs-6 d-inline-block">di sini</a>
    </div>
    <!-- <a [routerLink]="['/privacy-policy']">{{ 'Privacy & Policy' | translate }}</a> -->
    <!-- <a [routerLink]="['/terms-condition']">{{ 'Terms of Use' | translate }}</a> -->
  </div>
  <div class="footer-content right-content" *ngIf="!iS.isSukha">
    <h3>{{ 'Security of Your Transaction' | translate }}</h3>
    <div class="brand-container">
      <ng-container *ngIf="!iS.isSukha; else brandSukha">
        <img src="/assets/images/brands/Mastercard-logo.svg" alt="logo" loading="lazy">
        <img src="/assets/images/brands/Visa-logo.jpeg" alt="logo" loading="lazy">
        <img src="/assets/images/brands/JCB_logo.svg" alt="logo" loading="lazy">
        <!-- <img src="/assets/images/brands/4.svg" alt=""> -->
        <!-- <img src="/assets/images/brands/5.svg" alt=""> -->
      </ng-container>
      <ng-template #brandSukha>
        <img src="/assets/images/icons/mandiri.png" alt="logo" loading="lazy">
      </ng-template>
    </div>
  </div>
  <div class="copyright" *ngIf="!isIiccs">
    ©️ {{ yearNow }}. {{ (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? iS.getWhiteLabel?.promoter : 'PT Reservasi Multi Teknologi' )}}
  </div>
</footer>
